export default "__VITE_ASSET__f5044ad4__"